<template>
  <div v-if="loading" class="w-full p-4 flex flex-col items-center font-semibold bg-white mb-4">
    <p>
      {{ loadingText }} <span :class="loadingAnimation.first">.</span><span :class="loadingAnimation.second">.</span
      ><span :class="loadingAnimation.third">.</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      default() {
        return this.__('Ergebnisse werden geladen');
      },
    },
  },
  data() {
    return {
      loadingAnimation: { first: 'invisible', second: 'invisible', third: 'invisible' },
      count: 0,
    };
  },
  mounted() {
    this.loadAnimation();
  },
  methods: {
    loadAnimation() {
      switch (this.count) {
        case 0:
          this.loadingAnimation.first = 'invisible';
          this.loadingAnimation.second = 'invisible';
          this.loadingAnimation.third = 'invisible';
          break;
        case 1:
          this.loadingAnimation.first = 'loading-animation';
          break;
        case 2:
          this.loadingAnimation.second = 'loading-animation';
          break;
        case 3:
          this.loadingAnimation.third = 'loading-animation';
          break;
        default:
          break;
      }

      this.count++;
      if (this.count > 3) {
        this.count = 0;
      }
      setTimeout(this.loadAnimation, 1000);
    },
  },
};
</script>
<style scoped>
.loading-animation {
  opacity: 0;

  animation: fadeIn 1s;
  animation-fill-mode: forwards;
}

.invisible {
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
